import { createContext } from 'react';

export type ProvideDefaultPathsValue = {
  loginPath: string;
  homePath: string;
};
export const ProvideDefaultPathsContext = createContext<ProvideDefaultPathsValue>(null!);